import { render } from "./Team_home.vue?vue&type=template&id=72899b7d&scoped=true"
import script from "./Team_home.vue?vue&type=script&lang=js"
export * from "./Team_home.vue?vue&type=script&lang=js"

import "./Team_home.vue?vue&type=style&index=0&id=72899b7d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72899b7d"]])

export default __exports__